export { default as MapRestCarouselMobile } from './MapRestCarouselMobile'
